import { ITEM_COVERAGE_STATUSES } from '@/misc/desktopCharts'

export default function (value) {
  if (!value) {
    return '-'
  }
  const status = ITEM_COVERAGE_STATUSES.find(category => category.name === value)
  return status ? status.title : ''
}
